/* eslint-disable react-refresh/only-export-components */
import * as React from "react"
import { cva, type VariantProps } from "class-variance-authority"

import { cn } from "@/lib/utils"

const badgeVariants = cva(
  "inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2",
  {
    variants: {
      variant: {
        default:
          "border-transparent bg-primary text-primary-foreground hover:bg-primary/80",
        secondary:
          "border-transparent bg-secondary text-secondary-foreground hover:bg-secondary/80",
        destructive:
          "border-transparent bg-destructive text-destructive-foreground hover:bg-destructive/80",
        outline: "text-foreground",
        // Joey Brand Variants
        primary: "border-transparent bg-primary/10 text-brand-navy hover:bg-primary/20",
        success: "border-transparent bg-status-success-bg text-status-success hover:bg-status-success/10",
        warning: "border-transparent bg-status-warning-bg text-status-warning hover:bg-status-warning/10", 
        info: "border-transparent bg-blue-100 text-blue-800 hover:bg-blue-200",
        neutral: "border-transparent bg-muted text-brand-navy hover:bg-muted/80",
        // Category-specific variants
        safety: "border-transparent bg-status-success-bg text-status-success hover:bg-status-success/10",
        insights: "border-transparent bg-blue-100 text-blue-800 hover:bg-blue-200",
        controls: "border-transparent bg-primary/10 text-brand-navy hover:bg-primary/20",
        social: "border-transparent bg-status-warning-bg text-status-warning hover:bg-status-warning/10",
        alert: "border-transparent bg-orange-100 text-orange-800 hover:bg-orange-200",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  }
)

export interface BadgeProps extends React.HTMLAttributes<HTMLDivElement> {
  variant?: VariantProps<typeof badgeVariants>["variant"];
  children?: React.ReactNode;
  className?: string;
  key?: React.Key;
}

function Badge({ className, variant, ...props }: BadgeProps) {
  return (
    <div className={cn(badgeVariants({ variant }), className)} {...props} />
  )
}

export { Badge, badgeVariants }